<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-file-circle-check"></i></div>
      <div>
        Bulletins générés
        <div class="page-title-subheading">Bulletins déjà générés</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

<div  class="card mb-3">
  <div class="card-body py-3">
    <div class="row g-3 align-items-end">
      <div class="col-12 col-md-6">
        <label for="" class="form-label mb-0">Choisir la classe</label>
        <select class="form-select form-select-sm" (change)="loadCompositions1($event)" >
            <option selected disabled></option>
            <option *ngFor="let classroom of classrooms" [value]="classroom?.id">{{classroom?.name}}</option>
        </select>
      </div>
      <div class="col-12 col-md-6">
        <label for="" class="form-label mb-0">Choisir la période</label>
        <select class="form-select form-select-sm" [(ngModel)]="periodId" name="periodId" (change)="loadCompositions2($event)">
            <option selected disabled></option>
            <option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="container">
    <div class="d-flex justify-content-between mb-3">
        <div class="">
            <button *ngIf="is_published!=null && !is_published" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3">
                Activer</button>
               <button  *ngIf="is_published!=null &&  is_published" (click)="setStatus(0)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                Désactiver</button>
        </div>
        <div class="" *ngIf="pacId && periodId">
            <button class="btn btn-sm btn-primary" [disabled]="loading" (click)="getTemplate()">Voir le format de bulletin</button>
        </div>
    </div>
 <div class="card">
    <div class="card-body">
        <p>{{compositions!.length}} élément(s)</p>
        <div class="table-responsive">
        <table class="table table-sm table-bordered table-striped" >
            <thead class="">
                <tr>
                    <th style="width: 10px;">#</th>
                    <th>Elève</th>
                    <th>Voir le bulletin</th>
                </tr>
            </thead>
            <tbody>
                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of compositions  | paginate: {
                    id:'ngxP1',
                itemsPerPage: pg.pageSize,
                currentPage: pg.p,
                totalItems: pg.total }">
                    <td>
                        <div class="form-check mb-2">
                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                        
                        </div>
                    </td>
                    <td>{{d.sac?.student?.lastname}} {{d.sac?.student?.firstname}}</td>
                    <td>
                        <button class="btn btn-sm btn-primary" (click)="getFile2(d.name)">Voir le bulletin</button>
                    </td>
                 
                </tr>
            
            </tbody>
        </table>
        </div>

        <pagination-controls 
        id="ngxP1"
        (pageChange)="getPage($event)"
      [maxSize]="9"
      [directionLinks]="true"
      [autoHide]="true"
      [responsive]="true"
      [previousLabel]="'Previous'"
      [nextLabel]="'Next'"
      [screenReaderPaginationLabel]="'Pagination'"
      [screenReaderPageLabel]="'page'"
      [screenReaderCurrentLabel]="'You\'re on page'">
     </pagination-controls>
    </div>
 </div>
</div>

<ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>